export const maxUploadSize = 10 * 1000 * 1000; // 10MB in bytes in the SI system,
export const STORAGE_LIMIT_MESSAGE = `You've used all your storage space which is totally 1GB.`;
